export default "__VITE_ASSET__DKUpyned__"